module.exports = __webpack_public_path__ + "img/order-await.852fcb01.png";